import { render, staticRenderFns } from "./timetable.vue?vue&type=template&id=4b21a46b&scoped=true&"
import script from "./timetable.vue?vue&type=script&lang=js&"
export * from "./timetable.vue?vue&type=script&lang=js&"
import style0 from "./timetable.vue?vue&type=style&index=0&id=4b21a46b&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b21a46b",
  null
  
)

export default component.exports